import { HStack, Image, useColorModeValue } from '@chakra-ui/react'
import React from 'react'
import { useClient } from '../../core/client/ClientProvider'
import { useFeature } from '../../core/features/FeaturesProvider'
import { Feature } from '../../core/client/features.gen'

/** Optional client-owned signature; never supplies branding for other clients. */
export default function SidebarSignature() {
  const { config } = useClient()
  const newUi = useFeature(Feature.NEW_UI)
  const signature = config?.theme.chat?.sidebarSignature
  const taglineUrl = useColorModeValue(signature?.taglineUrl, signature?.taglineDarkModeUrl ?? signature?.taglineUrl)
  if (!signature || !newUi) return null
  return (
    <HStack
      role='img'
      aria-label={signature.label}
      data-testid='sidebar-signature'
      spacing={3}
      mx={2}
      pt={5}
      pb={1}
      align='center'
    >
      <Image src={taglineUrl} alt='' aria-hidden='true' flex='1' minW={0} w='0' h={6} objectFit='contain' />
      <Image src={signature.markUrl} alt='' aria-hidden='true' w={8} h='26px' objectFit='contain' flexShrink={0} />
    </HStack>
  )
}
